import fetcher from 'api/fetcher';
import { BannerValidatorDto, getValidateBannerErrors, getValidateBannerFields } from 'utils/banner/validation';
import { getActiveCropTypes } from 'utils/clickme';
import { MagritteNotificationName } from 'utils/constants/notification';

import bannerCreateStartFormSubmit from '@hh.ru/analytics-js-events/build/clickme/employer/common/banner_create_start_form_submit';
import bannerEditStartFormSubmit from '@hh.ru/analytics-js-events/build/clickme/employer/common/banner_edit_start_form_submit';

import { saveBanner } from 'components/BannerBuilder/BannerBuilderActions/saveBanner';
import { saveCrops } from 'components/common/BannerImg/CropImageModal/saveCrops';

import { BannerTextGenerationState } from 'store/models/bannerTextGeneration';
import { CreateBannerState, setBannerErrors } from 'store/models/createBanner';
import { addMagritteNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

const sendInternalAnalytics = (
    createBanner: CreateBannerState,
    bannerTextGeneration: BannerTextGenerationState,
    errors: BannerValidatorDto
) => {
    const { campaignIdForBanner, bannerId, bannerTitle: title, bannerText: text, bannerLink: url } = createBanner;
    const { bannerTextType, bannerTextGenerationCount } = bannerTextGeneration;

    const campaignId = Number(campaignIdForBanner);

    const analyticsDataBannerCreate = {
        campaignId,
        title,
        text,
        url,
        errors: JSON.stringify(errors),
        bannerTextType,
        triesCount: bannerTextGenerationCount,
    };
    const analyticsDataBannerEdit = {
        campaignId,
        bannerId,
        title,
        text,
        url,
        errors: JSON.stringify(errors),
        bannerTextType,
        triesCount: bannerTextGenerationCount,
    };

    if (!bannerId) {
        bannerCreateStartFormSubmit(analyticsDataBannerCreate);
        return;
    }
    bannerEditStartFormSubmit(analyticsDataBannerEdit);
};

export const validateAndSaveBanner = (
    setSaving: (isSaving: boolean) => void,
    dashboardRoute: string
): AppThunkAction => {
    return async (dispatch, getState) => {
        const { createBanner, bannerTextGeneration, createCampaign } = getState();
        const { adSource } = createCampaign;
        const activeCropTypes = getActiveCropTypes(adSource);

        const fields = getValidateBannerFields(createBanner, activeCropTypes);

        setSaving(true);
        try {
            if (createBanner.isCropsSaved) {
                await dispatch(saveCrops(activeCropTypes));
            }

            const errors = await fetcher.post<unknown, BannerValidatorDto>(`/api/v1/validator/banner`, fields);
            sendInternalAnalytics(createBanner, bannerTextGeneration, errors);
            if (Object.keys(errors).length > 0) {
                const stateErrors = getValidateBannerErrors(errors);
                dispatch([
                    setBannerErrors(stateErrors),
                    addMagritteNotification(MagritteNotificationName.CampaignFormFieldsError),
                ]);
            } else {
                await dispatch(saveBanner(activeCropTypes, dashboardRoute));
            }
        } catch (e) {
            dispatch(addMagritteNotification(MagritteNotificationName.CreateBannerSomethingWentWrongError));
        } finally {
            setSaving(false);
        }
    };
};
